import { useRef } from 'react';

import Block from 'shopper/components/Block';
import Button from 'shopper/components/Button';
import { Dropdown, DropdownItem } from 'shopper/components/Dropdown';
import Icon from 'shopper/components/Icon';
import Text from 'shopper/components/Text';

import useToggle from 'hooks/useToggle';

import { sendEvent } from 'lib/gtag';
import { getOfferPageEventCategory } from 'lib/offer';
import { shareOfferTo } from 'lib/share';

import ACTIONS from 'constants/action';
import SOCIAL_MEDIA from 'constants/socialMedia';

const SHAREABLE_SOCIAL_MEDIA = [
  {
    name: SOCIAL_MEDIA.WHATSAPP.TITLE,
    icon: <Icon name="whatsapp" color="#4CCA5A" />,
  },
  {
    name: SOCIAL_MEDIA.TELEGRAM.TITLE,
    icon: <Icon name="telegram" color="#2B9ED6" />,
  },
  {
    name: SOCIAL_MEDIA.FACEBOOK.TITLE,
    icon: <Icon name="facebook" color="#1877F2" />,
  },
  {
    name: SOCIAL_MEDIA.TWITTER.TITLE,
    icon: <Icon name="twitter" color="#1DA1F2" />,
  },
  {
    name: SOCIAL_MEDIA.EMAIL.TITLE,
    icon: <Icon name="email" color="#1DA1F2" />,
  },
];

const ShareDropdown = ({
  offerPrice,
  offerPriceType,
  offerStatusName,
  offerTitle,
}) => {
  const shareDropdownButtonElem = useRef();
  const [isOpen, setOpen] = useToggle();

  const onShare = (socialMedia) => {
    sendEvent({
      action: `share_${socialMedia.toLowerCase()}`,
      category: getOfferPageEventCategory(offerStatusName),
    });
    shareOfferTo({ offerTitle, offerPrice, offerPriceType, socialMedia });
  };

  return (
    <Block position="relative" height="fit-content" ml={[null, null, 2]} full>
      <Button
        type="subtle"
        size="size3"
        arial-label="Mais ações"
        iconLeft={<Icon name="share" />}
        ref={shareDropdownButtonElem}
        onClick={() => setOpen(true)}
      >
        {ACTIONS.SHARE}
      </Button>
      <Dropdown
        openerRef={shareDropdownButtonElem}
        open={isOpen}
        onClickOutside={() => setOpen(false)}
      >
        {SHAREABLE_SOCIAL_MEDIA.map(({ icon, name }) => (
          <DropdownItem
            key={name}
            aria-label={`Compartilhar oferta no ${name}`}
            onClick={() => onShare(name)}
          >
            {icon}
            <Text size="size2" ml={[2, null, 4]}>
              {name}
            </Text>
          </DropdownItem>
        ))}
      </Dropdown>
    </Block>
  );
};

export default ShareDropdown;
